/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { Stack } from '@fluentui/react/lib/Stack';
import { observer } from 'mobx-react';
import * as React from 'react';
import { defineMessages } from 'react-intl';
import { GlobalHeaderLinks } from 'src/appShell/globalHeader/utils/globalHeaderLinks';
import { ExternalLink } from 'src/core/components/ExternalLink';
import { useLocalization } from 'src/core/hooks/useLocalization';

const messages = defineMessages({
    ticketLink: { id: 'portal.globalFeedbackBlade.ticketLink', defaultMessage: 'Create Azure support request to get help.' },
    forumLink: { id: 'portal.globalFeedbackBlade.forumLink', defaultMessage: 'Go to the Forum to share your ideas and feature requests.' }
});

/**
 * Renders the feedback blade that contains links and
 * controls for users to give feedback on our glorious product.
 */
export const GlobalFeedbackBlade = observer(() => {
    const { localize } = useLocalization();

    return (
        <Stack verticalAlign="space-evenly" tokens={{ childrenGap: 10 }} grow>
            <ExternalLink href={GlobalHeaderLinks.feedbackForumLink}>{localize(messages.forumLink)}</ExternalLink>

            <ExternalLink href={GlobalHeaderLinks.requestTicketLink}>{localize(messages.ticketLink)}</ExternalLink>
        </Stack>
    );
});
